import { CompanyState } from "../types";

const state: CompanyState = {
  ubos: [],
  newUBO: {
    firstName: "",
    lastName: "",
    email: "",
    mobileNumber: null,
    type: "",
  },
};

export default state;
